module.exports = __webpack_public_path__ + "img/ops_logo_pt.42c4886c.svg";